import type { IMediaSchema } from '@monofe/streamlib';
import type { MediaBinaryStorageTypeMap } from '../../controller/interface/media';
import type { IContainer } from '../../interface/container';
import { injectProgressPromise, IProgressPromise } from '../../interface/promise';
import { injectFetch } from '../../interface/util';
import type { IMediaAPI, IMediaURLResolverParameters } from '../interface/media';
import mediaImpl from './mediaStream';

function media(container: IContainer, schema: IMediaSchema, schemaURL: string) {
    const promiser = injectProgressPromise(container);
    const fetcher = injectFetch(container);

    const urlPrefix = schemaURL.replace('/media.json', '');

    const module: IMediaAPI = {
        getMedia: <
            T extends keyof MediaBinaryStorageTypeMap,
            U extends MediaBinaryStorageTypeMap[T],
        >(
            type: T,
            mediaId: string,
            parameters?: IMediaURLResolverParameters,
        ) =>
            mediaImpl.getMedia(
                promiser,
                fetcher,
                schema,
                urlPrefix,
                type,
                mediaId,
                parameters ?? {},
            ) as IProgressPromise<U>,

        /* IMediaURLResolver */
        canResolveMedium: (mediaId: string) => mediaImpl.canResolveMedium(schema, mediaId),

        requestURL: (mediaId: string, parameters: IMediaURLResolverParameters = {}) =>
            mediaImpl.requestURL(schema, urlPrefix, mediaId, parameters),
    };

    return module;
}

export default media;
